const getters = {
  getConstant(state) {
    return state.constants;
  }
};

export default getters;
